import createCachedSelector from 're-reselect';
import * as paramsSelector from './params';
import * as scenariosSelector from './scenario';
import { commonPageInfoReducer } from '../reducers';
import { mapValues } from 'lodash';

/**
 * Considers all Regession scenarios in current page context with a matching
 * selected failure reason, tries to pull a param out as dictated by the given paramFunc
 * and then stores it into a key as dictated by the given groupFunc
 */
export const regressionFailureTrendsDataAndLabels = createCachedSelector(
  paramsSelector.getScenarioParamsByRunnerId,
  scenariosSelector.regressionFailureTrendsScenariosByReason,
  commonPageInfoReducer.getSelectedFailureReason,
  (_state, paramFunc) => paramFunc,
  (_state, _paramFunc, groupFunc) => groupFunc,
  (paramsByRunnerId, scenariosByReason, selectedReasonType, paramFunc, groupFunc) => {
    const concerningScenarios =
      (selectedReasonType && scenariosByReason[selectedReasonType]) || [];

    // pull the relevant piece of data for each scenario
    const groupedData = concerningScenarios.reduce((acc, scenario) => {
      const params = paramsByRunnerId[scenario.runner] || {};

      // * Most straightforward to keep 'paramValue' a single value
      // * but since not all jobs report the exact same params
      // so maybe here we need to support the possibility of multiple
      // concerning params as an arry if needed in the future
      const paramValue = paramFunc(params, scenario) || undefined;
      if (paramValue) {
        const groupValue = groupFunc(paramValue, scenario) || '';
        acc[groupValue] = [...(acc[groupValue] || []), paramValue];
      }
      return acc;
    }, {});

    // then we need to replace the values by their counts
    const tallied = mapValues(groupedData, (groupData) => groupData.length);

    const result = { data: Object.values(tallied), labels: Object.keys(tallied) };
    return result;
  }
)(
  (_state, _paramFunc, _groupFunc, cacheKey) => cacheKey
);


// WEBPACK FOOTER //
// src/selectors/charts.js